import React, { useState } from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import male from "../assets/svg/male.svg";
import maletrue from "../assets/svg/maletrue.svg";
import female from "../assets/svg/female.svg";
import femaletrue from "../assets/svg/femaletrue.svg";
import bmale1 from "../assets/svg/bshape/bmale1.svg";
import bmale2 from "../assets/svg/bshape/bmale2.svg";
import bmale3 from "../assets/svg/bshape/bmale3.svg";
import bmale4 from "../assets/svg/bshape/bmale4.svg";
import bmale5 from "../assets/svg/bshape/bmale5.svg";
import bmale1true from "../assets/svg/bshape/bmale1true.svg";
import bmale2true from "../assets/svg/bshape/bmale2true.svg";
import bmale3true from "../assets/svg/bshape/bmale3true.svg";
import bmale4true from "../assets/svg/bshape/bmale4true.svg";
import bmale5true from "../assets/svg/bshape/bmale5true.svg";
import fmale1 from "../assets/svg/bshape/fmale1.svg";
import fmale2 from "../assets/svg/bshape/fmale2.svg";
import fmale3 from "../assets/svg/bshape/fmale3.svg";
import fmale4 from "../assets/svg/bshape/fmale4.svg";
import fmale5 from "../assets/svg/bshape/fmale5.svg";
import fmale1true from "../assets/svg/bshape/fmale1true.svg";
import fmale2true from "../assets/svg/bshape/fmale2true.svg";
import fmale3true from "../assets/svg/bshape/fmale3true.svg";
import fmale4true from "../assets/svg/bshape/fmale4true.svg";
import fmale5true from "../assets/svg/bshape/fmale5true.svg";
import checked from "../assets/svg/checked.svg";
import Loading from "../components/elements/LoadingAnimation";
import Stepper from "../components/stepper/Stepper";
import { useStepper } from "../components/stepper/context";
import { useAuth } from "../context/auth";
import { navigate } from "@reach/router";

const Header = styled.h1`
  width: 70px;
  height: 24px;
  margin-top: 20px;
  margin-left: 14px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
  text-align: center;
`;

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;

const NextBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

const Title = styled.h1`
  height: 24px;
  margin-top: 20px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
  text-align: center;
`;

const BigBtn = styled.button`
  background: #171111;
  box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.35),
    -5px -5px 25px rgba(56, 56, 56, 0.3);
  border-radius: 24px;
  border: none;
  width: 18vh;
`;

const Errors = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #ff5c5c;
  margin-left: 20px;
  margin-top: 5px;
`;

const SmallBtn = styled.button`
  background: #171111;
  box-shadow: 5px 5px 25px rgba(0, 0, 0, 0.35),
    -5px -5px 25px rgba(56, 56, 56, 0.3);
  border-radius: 24px;
  border: none;
  width: 54px;
  height: 117px;
`;

const CircleBtn = styled.button`
  border-radius: 24px;
  border: none;
  width: 45px;
  height: 45px;
  &:focus {
    background: #261c1c;
  }
`;

const SvgImg = styled.img`
  height: 35vh;
`;

const SvgImg2 = styled.img`
  height: 14vh;
`;

const SvgImg3 = styled.img`
  background: rgba(4, 3, 3, 0.5);
  border-radius: 50%;
  width: 29px;
  height: 29px;
`;

const BtnLabel = styled.p`
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  color: #fffcf2;
`;

const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: rgba(255, 252, 242, 0.3);
  width: 40vh;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;

const FormLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
`;

const Backdrop = styled.div`
  height: 100%;
  width: 100%;
  backdrop-filter: blur(4px);
  position: absolute;
  z-index: 1;
`;

const StepBody = styled.div`
  text-align: center;
`;
export default function AddTraitForm() {
  const { SignatureKey, AddTrait } = useAuth();
  const [showLoader, setShowLoader] = useState(false);
  const { incrementCurrentStep, decrementCurrentStep } = useStepper(); //increment function for custom stepper
  const [goSteps, setGoSteps] = useState(0);
  const [activeGender, setActiveGender] = useState("");
  const [maleMode, setMaleMode] = useState(false);
  const [femaleMode, setFemaleMode] = useState(false);
  const [body1, setBody1] = useState(false);
  const [body2, setBody2] = useState(false);
  const [body3, setBody3] = useState(false);
  const [body4, setBody4] = useState(false);
  const [body5, setBody5] = useState(false);
  const [skin1, setSkin1] = useState(false);
  const [skin2, setSkin2] = useState(false);
  const [skin3, setSkin3] = useState(false);
  const [skin4, setSkin4] = useState(false);
  const [skin5, setSkin5] = useState(false);
  const [skin6, setSkin6] = useState(false);
  const [skin7, setSkin7] = useState(false);
  const [skin8, setSkin8] = useState(false);
  const [skin9, setSkin9] = useState(false);

  const completeFormStep = () => {
    setGoSteps((cur) => cur + 1);
    incrementCurrentStep();
  };
  const renderButton = () => {
    if (goSteps === 2) {
      return <NextBtn type="submit">Create account</NextBtn>;
    } else {
      return (
        <NextBtn type="button" onClick={completeFormStep}>
          Next
        </NextBtn>
      );
    }
  };

  const renderTitle = () => {
    if (goSteps === 0) {
      return <Title>Gender</Title>;
    } else if (goSteps === 1) {
      return <Title>Biometrics</Title>;
    } else {
      return <Title>Body Shape</Title>;
    }
  };

  const {
    watch,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    // resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    // window.alert(JSON.stringify(watch(), null, 2));
    SignatureKey(
      data.gender,
      data.height,
      data.skinTone,
      data.bodyShape,
      data.age,
      data.weight,
      data.dob
    )
      .then((response) => {
        setShowLoader(true);
        AddTrait(
          data.gender,
          data.height,
          data.skinTone,
          data.bodyShape,
          data.age,
          data.weight,
          data.dob
        );
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      })
      .catch((err) => {
        console.log("error");
      });
  };

  const text = "Creating profile...";
  return (
    <>
      <div>
        <BackBtn>
          <i class="fa fa-ellipsis-h"></i>
        </BackBtn>
      </div>
      <div>
        <Header>Sign Up</Header>
      </div>
      <div>{renderTitle()}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stepper>
          <Stepper.Steps>
            <Stepper.Step id="fourth">
              {goSteps === 0 && (
                <>
                  <div className="d-flex justify-content-between px-4">
                    <input
                      style={{ display: "none" }}
                      {...register("gender", {
                        required: true,
                      })}
                    ></input>
                    <BigBtn
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveGender("male");
                        setMaleMode(true);
                        setFemaleMode(false);
                        setValue("gender", "male", {
                          shouldValidate: true,
                          shouldDirty: true,
                        });
                      }}
                    >
                      <SvgImg src={maleMode ? maletrue : male} />
                      <BtnLabel>Male</BtnLabel>
                    </BigBtn>
                    <BigBtn
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveGender("female");
                        setMaleMode(false);
                        setFemaleMode(true);
                        setValue("gender", "female", {
                          shouldValidate: true,
                          shouldDirty: true,
                        });
                      }}
                    >
                      <SvgImg src={femaleMode ? femaletrue : female} />
                      <BtnLabel>Female</BtnLabel>
                    </BigBtn>
                  </div>
                </>
              )}
            </Stepper.Step>
            <Stepper.Step id="fifth">
              {goSteps === 1 && (
                <>
                  <section>
                    <div>
                      <FormLabel>Date Of birth:</FormLabel>
                    </div>
                    <div className="d-flex justify-content-center">
                      <FormInput
                        type="date"
                        {...register("dob", {
                          required: true,
                        })}
                      />
                    </div>
                    {errors.dob && (
                      <Errors>Please enter your date of birth</Errors>
                    )}
                    <div style={{ marginTop: "15px" }}>
                      <FormLabel>Height:</FormLabel>
                    </div>
                    <div className="d-flex justify-content-center">
                      <FormInput
                        placeholder="cm"
                        {...register("height", {
                          required: true,
                        })}
                      />
                    </div>
                    {errors.height && <Errors>Please enter your height</Errors>}
                    <div style={{ marginTop: "15px" }}>
                      <FormLabel>Weight:</FormLabel>
                    </div>
                    <div className="d-flex justify-content-center">
                      <FormInput
                        placeholder="Kg"
                        {...register("weight", {
                          required: true,
                        })}
                      />
                    </div>
                    {errors.weight && <Errors>Please enter your weight</Errors>}
                  </section>
                </>
              )}
            </Stepper.Step>
            <Stepper.Step id="sixth">
              {goSteps === 2 && (
                <>
                  <Loading active={showLoader} text={text}>
                    <section>
                      <div>
                        <FormLabel>Body shape:</FormLabel>
                      </div>

                      <div className="d-flex justify-content-between px-3">
                        <input
                          style={{ display: "none" }}
                          {...register("bodyShape", {
                            required: true,
                          })}
                        ></input>
                        <input
                          style={{ display: "none" }}
                          {...register("skinTone", {
                            required: true,
                          })}
                        ></input>
                        {activeGender === "male" ? (
                          <>
                            <SmallBtn
                              onClick={() => {
                                setBody1(true);
                                setBody2(false);
                                setBody3(false);
                                setBody4(false);
                                setBody5(false);
                                setValue("bodyShape", "slender", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body1 ? bmale1true : bmale1} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(true);
                                setBody3(false);
                                setBody4(false);
                                setBody5(false);
                                setValue("bodyShape", "rectangle", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body2 ? bmale2true : bmale2} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(false);
                                setBody3(true);
                                setBody4(false);
                                setBody5(false);
                                setValue("bodyShape", "triangle", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body3 ? bmale3true : bmale3} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(false);
                                setBody3(false);
                                setBody4(true);
                                setBody5(false);
                                setValue("bodyShape", "muscular", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body4 ? bmale4true : bmale4} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(false);
                                setBody3(false);
                                setBody4(false);
                                setBody5(true);
                                setValue("bodyShape", "oval", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body5 ? bmale5true : bmale5} />
                            </SmallBtn>
                          </>
                        ) : (
                          <>
                            <SmallBtn
                              onClick={() => {
                                setBody1(true);
                                setBody2(false);
                                setBody3(false);
                                setBody4(false);
                                setBody5(false);
                                setValue("bodyShape", "slender", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body1 ? fmale1true : fmale1} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(true);
                                setBody3(false);
                                setBody4(false);
                                setBody5(false);
                                setValue("bodyShape", "rectangle", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body2 ? fmale2true : fmale2} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(false);
                                setBody3(true);
                                setBody4(false);
                                setBody5(false);
                                setValue("bodyShape", "triangle", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body3 ? fmale3true : fmale3} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(false);
                                setBody3(false);
                                setBody4(true);
                                setBody5(false);
                                setValue("bodyShape", "muscular", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body4 ? fmale4true : fmale4} />
                            </SmallBtn>
                            <SmallBtn
                              onClick={() => {
                                setBody1(false);
                                setBody2(false);
                                setBody3(false);
                                setBody4(false);
                                setBody5(true);
                                setValue("bodyShape", "oval", {
                                  shouldValidate: true,
                                  shouldDirty: true,
                                });
                              }}
                            >
                              <SvgImg2 src={body5 ? fmale5true : fmale5} />
                            </SmallBtn>
                          </>
                        )}
                      </div>
                      <div style={{ marginTop: "15px" }}>
                        <FormLabel>Skin tone:</FormLabel>
                      </div>
                      <div className="d-flex justify-content-between px-3">
                        <CircleBtn
                          style={{ background: "#f4e6d0" }}
                          onClick={() => {
                            setSkin1(true);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", "very fair", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin1 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: " #eedabd" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(true);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", "fair", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin2 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: "#eacfa8" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(true);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", "medium", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin3 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: "#d7bb91" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(true);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", "olive", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin4 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: "#c6a57d" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(true);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", "honey", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin5 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: "#a47950" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(true);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", "brown", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin6 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                      </div>
                      <div className="d-flex justify-content-between mt-2  px-3">
                        <CircleBtn
                          style={{ background: "#7b6752" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(true);
                            setSkin8(false);
                            setSkin9(false);
                            setValue("skinTone", " dark brown", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin7 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: " #6c4120" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(true);
                            setSkin9(false);
                            setValue("skinTone", "bronze", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin8 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn
                          style={{ background: "#23160a" }}
                          onClick={() => {
                            setSkin1(false);
                            setSkin2(false);
                            setSkin3(false);
                            setSkin4(false);
                            setSkin5(false);
                            setSkin6(false);
                            setSkin7(false);
                            setSkin8(false);
                            setSkin9(true);
                            setValue("skinTone", "chocolate", {
                              shouldValidate: true,
                              shouldDirty: true,
                            });
                          }}
                        >
                          {skin9 ? <SvgImg3 src={checked} /> : <></>}
                        </CircleBtn>
                        <CircleBtn style={{ background: "transparent" }} />
                        <CircleBtn style={{ background: "transparent" }} />
                        <CircleBtn style={{ background: "transparent" }} />
                      </div>
                    </section>
                  </Loading>
                </>
              )}
            </Stepper.Step>
          </Stepper.Steps>
        </Stepper>
        <div style={{ marginTop: "20px", marginBottom: "20px" }}>
          {renderButton()}
        </div>
      </form>
    </>
  );
}
